import { lsStorageService } from 'ls-vue-common';
import { TURNSTILE_TOKEN } from '@/services/storage/storage-key.constants';
import {
    ERROR__CLEAR_ERROR,
    LOADING__QUOTING_ORDER,
    TURNSTILE__MUTATE_TOKEN,
    TURNSTILE__DISPLAY_LOADING_SPINNER,
    TURNSTILE__SAVE_TOKEN,
} from '../types';

export const mutations = {
    [TURNSTILE__MUTATE_TOKEN](_localState, { token }) {
        lsStorageService.set(TURNSTILE_TOKEN, token);
    },
};

export const actions = {
    [TURNSTILE__SAVE_TOKEN]({ commit }, payload) {
        commit(TURNSTILE__MUTATE_TOKEN, payload);
    },

    [TURNSTILE__DISPLAY_LOADING_SPINNER]({ dispatch }) {
        dispatch(ERROR__CLEAR_ERROR);
        dispatch(LOADING__QUOTING_ORDER);
    },
};

export const turnstile = {
    getters: {},
    mutations,
    actions,
};
